module.exports = __webpack_public_path__ + "assets/img/title-e372790e.png";